export enum AccessType {
    PUBLIC = "public",
    LIMITED = "limited",
    DISABLED = "disabled"
}

export interface IAccessLLMModel {
    id?: string;
    accessType: AccessType;
    name: string;
    displayName: string;
    order: number;
    allowedUsers: string[];
};